
import React from 'react';

interface VerifiedLabelProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const VerifiedLabel: React.FC<VerifiedLabelProps> = ({ className = '', size = 'md' }) => {
  // Adjust text size based on the size prop
  const textSizeClass = size === 'sm' ? 'text-xs' : 
                        size === 'lg' ? 'text-sm' : 
                        'text-xs';
  
  // Adjust padding based on the size prop
  const paddingClass = size === 'sm' ? 'px-1 py-0.5' :
                       size === 'lg' ? 'px-3 py-1.5' :
                       'px-2 py-1';
  
  return (
    <div className={`${paddingClass} bg-secondary-100 text-secondary-700 ${textSizeClass} font-medium rounded-full whitespace-nowrap ${className}`}>
      CGM Verified
    </div>
  );
};

export default VerifiedLabel;
